import { Controller } from "@hotwired/stimulus";

// Displays a bank-statement amount input with thousands separators for
// readability, while keeping a clean numeric value while the user is editing
// (and for form submission — the server also strips commas as a safeguard).
export default class extends Controller {
  connect() {
    this.format();
  }

  // Strip separators so the field is easy to edit and recalc parses cleanly.
  unformat() {
    this.element.value = this.raw();
  }

  // Re-apply thousands separators when the user leaves the field.
  format() {
    const raw = this.raw();
    if (raw === "" || isNaN(Number(raw))) return;

    const negative = raw.startsWith("-");
    const [intPart, decPart] = raw.replace("-", "").split(".");
    const withCommas = Number(intPart).toLocaleString("en-US");
    const sign = negative ? "-" : "";
    this.element.value = decPart != null ? `${sign}${withCommas}.${decPart}` : `${sign}${withCommas}`;
  }

  raw() {
    return this.element.value.replace(/,/g, "").trim();
  }
}
